var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6H12V7.5H22.5V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5H12V18H22.5V16.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H3C2.60232 10.4995 2.22105 10.3414 1.93984 10.0602C1.65864 9.77895 1.50046 9.39768 1.5 9V4.5C1.50046 4.10232 1.65864 3.72105 1.93984 3.43984C2.22105 3.15864 2.60232 3.00046 3 3H7.5C7.89768 3.00046 8.27895 3.15864 8.56016 3.43984C8.84136 3.72105 8.99954 4.10232 9 4.5V9C8.99954 9.39768 8.84136 9.77895 8.56016 10.0602C8.27895 10.3414 7.89768 10.4995 7.5 10.5ZM3 4.5V9H7.5009L7.5 4.5H3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21H3C2.60232 20.9995 2.22105 20.8414 1.93984 20.5602C1.65864 20.2789 1.50046 19.8977 1.5 19.5V15C1.50046 14.6023 1.65864 14.221 1.93984 13.9398C2.22105 13.6586 2.60232 13.5005 3 13.5H7.5C7.89768 13.5005 8.27895 13.6586 8.56016 13.9398C8.84136 14.221 8.99954 14.6023 9 15V19.5C8.99954 19.8977 8.84136 20.2789 8.56016 20.5602C8.27895 20.8414 7.89768 20.9995 7.5 21ZM3 15V19.5H7.5009L7.5 15H3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcList);
export default __webpack_public_path__ + "static/media/ic-list.15d3dc3ed8982c8e0241c7c494e8d439.svg";
export { ForwardRef as ReactComponent };